import { EEntityType } from '@/editor/types';
import { OperateAbstract } from './OperateAbstract';
import { IPoint2d } from '@/editor/math/IPoint2d';
import ModelGroupEntity from '@/editor/entities/modelGroupEntity';
import { moveModelGroupInfo } from '../../utils';
import { globalStores } from '@/editor/stores';

export class OperateModelGroup extends OperateAbstract<EEntityType.ModelGroup> {
  private _checkedEntity: ModelGroupEntity | null | undefined = null;
  set checkedEntity(entity: ModelGroupEntity | null | undefined) {
    if (!entity) return;

    this._checkedEntity = entity;
  }

  get checkedEntity() {
    return this._checkedEntity;
  }

  move(point: IPoint2d) {
    this.moving = true;

    if (!this._checkedEntity) {
      return point;
    }
    const modelGroupData = globalStores.modelGroupStore.getModelGroupData(this._checkedEntity.id);
    if (!modelGroupData) return point;

    const { newModelGroupData } = moveModelGroupInfo(point, modelGroupData);

    globalStores.modelGroupOperation.modifyModelGroup(this._checkedEntity.id, newModelGroupData);

    return [newModelGroupData.center, newModelGroupData.rotation] satisfies [IPoint2d, number];
  }

  completeMove(_point: IPoint2d) {
    this.moving = false;
  }

  clear() {
    this.checkedEntity = null;
    this.moving = false;
    this.pickPoint = null;
  }

  dispose() {
    this.clear();

    // TODO: 待完善
  }
}
